function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M20.624 53.686L0 64v181.02l20.624 10.254.124-.149V53.828l-.124-.142",
  fill: "#8C3123"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M131 229L20.624 255.274V53.686L131 79.387V229",
  fill: "#E05243"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M81.178 187.866l46.818 5.96.294-.678.263-76.77-.557-.6-46.818 5.874v66.214",
  fill: "#8C3123"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M127.996 229.295l107.371 26.035.169-.269-.003-201.195-.17-.18-107.367 25.996v149.613",
  fill: "#8C3123"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M174.827 187.866l-46.831 5.96v-78.048l46.831 5.874v66.214",
  fill: "#E05243"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M174.827 89.631l-46.831 8.535-46.818-8.535 46.759-12.256 46.89 12.256",
  fill: "#5E1F18"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M174.827 219.801l-46.831-8.591-46.818 8.591 46.761 13.053 46.888-13.053",
  fill: "#F2B0A9"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M81.178 89.631l46.818-11.586.379-.117V.313L127.996 0 81.178 23.413v66.218",
  fill: "#8C3123"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M174.827 89.631l-46.831-11.586V0l46.831 23.413v66.218",
  fill: "#E05243"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M127.996 309.428l-46.823-23.405v-66.217l46.823 11.582.689.783-.187 75.906-.502 1.351",
  fill: "#8C3123"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M127.996 309.428l46.827-23.405v-66.217l-46.827 11.582v78.04M235.367 53.686L256 64v181.02l-20.633 10.31V53.686",
  fill: "#E05243"
});

const SvgS3 = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 2065,
  height: 2500,
  viewBox: "0 0 256 310",
  preserveAspectRatio: "xMidYMid",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgS3, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/s3.78fd575f.svg";
export { ForwardRef as ReactComponent };